import $ from 'jquery';
import Tooltip from 'root/module/tooltip';
import View from 'view/base';

var Modal = {
    _overlay: null,
    _modal: null,

    _onclose: null,

    open: function(options) {
        Tooltip.removeAll();

        if (this._modal) {
            this._forceClose(true);
        }

        $(document.body).addClass('modal-open');

        if (options.fullscreen) {
            $(document.body).addClass('modal-fullscreen-open');
        }

        if (!this._overlay) {
            this._overlay = $('<div>').addClass('overlay');

            if (options.fullscreen) {
                this._overlay.addClass('overlay-fullscreen');
            }

            this._overlay.appendTo($(document.body));

            if (options.close !== false) {
                $(document).on('keyup', $.proxy(this._documentKeyup, this));
            }
        }

        this._modal = $('<div>').addClass('modal');

        if (options.fullscreen) {
            this._modal.addClass('modal-fullscreen');
        }

        if (options.inner_scroll) {
            this._modal.addClass('modal-inner-scroll');

            if (!options.button) {
                this._modal.addClass('modal-inner-scroll-nobutton');
            }
        }

        if (options.nopadding) {
            this._modal.addClass('modal-nopadding');
        }

        if (options.edgeless) {
            this._modal.addClass('modal-edgeless');
        }

        if (options.theme) {
            this._modal.addClass(options.theme);
        }

        // close button
        if (options.close !== false) {
            $('<button>')
                .attr('type', 'button')
                .addClass('modal-button-close btn-close')
                .html('<i class="fa-regular fa-xmark"></i>')
                .on('click', this.close.bind(this))
                .appendTo(this._modal);
        }

        // title
        if (options.notitle !== true) {
            if (options.title_html) {
                $('<div>').addClass('modal-title').html(options.title_html).appendTo(this._modal);
            } else {
                $('<div>').addClass('modal-title').text(options.title || '').appendTo(this._modal);
            }
        } else {
            this._modal.addClass('modal-notitle');
        }

        // content
        $('<div>').addClass('modal-content').html(options.content || '').appendTo(this._modal);

        // when the modal content is a backbone view, render it
        if (options.content instanceof View) {
            options.content.render().$el.appendTo(this._modal.find('.modal-content'));
        }

        // button
        if (options.button) {
            var button_section = $('<div>').addClass('modal-button').appendTo(this._modal);

            var context = options.context || this;

            $.each(options.text_link, function(label, event_handler) {
                var link = $('<a>').attr('href', '#').text(label).appendTo(button_section).on('click', function(e) {
                    e.preventDefault();
                    event_handler.call(context, e, context._modal);
                });

                if (options.text_link_class) {
                    link.addClass(options.text_link_class);
                }

                if (options.text_link_classes) {
                    link.addClass(options.text_link_classes);
                }
            });

            $.each(options.button, function(label, event_handler) {
                var button_class = options.button_class || 'primary';

                var button = $('<button>').attr('type', 'button').addClass(button_class).text(label).appendTo(button_section).on('click', function(e) {
                    event_handler.call(context, e, context._modal);
                });

                if (options.button_disabled) {
                    button.prop('disabled', true);
                }
            });

            if (options.button_html) {
                $(options.button_html).prependTo(button_section);
            }
        } else {
            this._modal.addClass('modal-nobutton');
        }

        if (options.width) {
            this._modal.width(options.width);
        }

        if (options.onclose) {
            this._onclose = options.onclose;
        } else {
            this._onclose = null;
        }

        this._modal.appendTo(this._overlay);

        return this._modal;
    },

    setTitle: function(title) {
        this._modal.find('.modal-title').text(title);
    },

    setContent: function(content) {
        this._modal.find('.modal-content').html(content);
    },

    removeClose: function() {
        this._modal.find('.modal-button-close').remove();
    },

    removeButton: function() {
        this._modal.find('.modal-button').remove();
        this._modal.addClass('modal-nobutton');
    },

    focusButton: function() {
        this._modal.find('.modal-button button:first').focus();
    },

    confirm: function(message, callback, context, button_text, title, button_class) {
        context     = context     || this;
        button_text = button_text || 'OK';
        title       = title       || 'Confirm';

        var button = {};

        button[button_text] = function(e) {
            callback.call(context, e, this._modal);
            Modal.close();
        };

        this.open({
            title: title,
            content: message,
            button: button,
            text_link: {
                Cancel: function(e) {
                    e.preventDefault();
                    Modal.close();
                }
            },
            button_class: button_class
        });

        // focus the first button
        this.focusButton();

        return this._modal;
    },

    warn: function() {
        var modal = this.confirm.apply(this, arguments);
        modal.find('.modal-button button.primary').removeClass('primary').addClass('danger');
    },

    message: function(title, message) {
        this.open({
            title: title,
            content: message
        });

        return this._modal;
    },

    close: function() {
        if (!this._modal) {
            return;
        }

        $(document.body).removeClass('modal-open modal-fullscreen-open');

        $(document).off('keyup', $.proxy(this._documentKeyup, this));

        if (this._onclose) {
            this._onclose(this._modal);
        }

        this._forceClose();
    },

    _documentKeyup: function(e) {
        if (e.which === 27) {
            this.close();
        }
    },

    _forceClose: function(skip_overlay) {
        if (this._modal) {
            this._modal.remove();
            this._modal = null;
        }

        if (skip_overlay !== true && this._overlay) {
            this._overlay.remove();
            this._overlay = null;
        }
    }
};

export default Modal;
